<!--
 * @Author: cmchiu
 * @Date: 2023-01-03 17:26:40
 * @LastEditTime: 2023-02-03 17:16:12
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \LearningMarket2\LearningMarket-ClientApp\src\components\CourseDemand\coursedemand.vue
 * 
-->
<template>
    <div class="course-demand">
        <!-- 開課需求調查 -->
        <div class="row">
            <div class="col-lg-12 survey">
                <a href="#" data-bs-toggle="modal" data-bs-target="#exampleModal">開課需求調查</a>
            </div>
        </div>
        <div
            class="modal fade"
            id="exampleModal"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            v-loading.lock="configs.loading"
            element-loading-text="請稍候，目前正處理開課需求中..."
            element-loading-background="rgba(255, 255, 255, 0.5)"
        >
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="survey_modal_header">
                        <div class="survey_img mb-2">
                            <img src="assets/images/learningmarket/survey.png" alt="" />
                        </div>
                        <div>
                            <h5 class="modal-title survey_modal_title" id="exampleModalLabel">開課需求調查</h5>
                        </div>
                    </div>
                    <div class="modal-body survey_modal_body">
                        <el-form
                            ref="form"
                            :model="demand"
                            :rules="demandRules"
                            label-width="25%"
                            hide-required-asterisk
                        >
                            <el-form-item label-width="auto">
                                <div class="text_sub">歡迎您告訴我們未來希望開設哪些學習市集課程，謝謝！</div>
                            </el-form-item>

                            <el-form-item label="課程分類" prop="courseType">
                                <el-select
                                    v-model="demand.courseType"
                                    placeholder="請選擇課程分類"
                                    :popper-append-to-body="false"
                                    class="form-el-select"
                                >
                                    <el-option
                                        v-for="item in courseType4Demand"
                                        :key="item.para_no"
                                        :label="item.para_dispname"
                                        :value="item.para_no"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="課程名稱" prop="courseName">
                                <el-input v-model="demand.courseName" type="text" :maxlength="200"></el-input>
                            </el-form-item>

                            <el-form-item label="需求描述" prop="courseDescription">
                                <el-input
                                    v-model="demand.courseDescription"
                                    type="textarea"
                                    resize="none"
                                    :maxlength="2000"
                                ></el-input>
                            </el-form-item>

                            <el-form-item v-if="!user.isLogin" style="margin-bottom: 0px">
                                <div style="color: red">請先登入系統。</div>
                            </el-form-item>

                            <el-form-item label-width="auto" v-else>
                                <div class="text_sub">請留下您的連絡方式</div>
                            </el-form-item>

                            <el-form-item label="姓名" prop="contactName" v-show="user.isLogin && false">
                                <el-input
                                    v-model="demand.contactName"
                                    type="text"
                                    :maxlength="30"
                                    :disabled="user.isLogin"
                                ></el-input>
                            </el-form-item>

                            <el-form-item label="Email" prop="contactEmail" v-show="user.isLogin">
                                <el-input v-model="demand.contactEmail" type="text" :maxlength="50"></el-input>
                            </el-form-item>

                            <el-form-item label="聯絡電話" prop="contactPhone" v-show="user.isLogin">
                                <el-input
                                    v-model="demand.contactPhone"
                                    type="text"
                                    placeholder="例: 0912-345678 或 02-27005858"
                                    :maxlength="20"
                                ></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="survey_footer">
                        <button type="button" class="btn survey_btnclose" data-bs-dismiss="modal" ref="btnCancel">
                            取消
                        </button>
                        <button
                            type="button"
                            class="btn survey_btnsubmit"
                            :class="user.isLogin ? '' : 'not-allowed'"
                            :disabled="!user.isLogin"
                            @click="submitDemand"
                        >
                            送出
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- ---------------- -->
    </div>
</template>

<script>
import XEUtils from 'xe-utils'
import { checkPhone, checkEmail } from '@/utils/common'
import { getCourseType4Demand, submitCourseDemand } from '@/api/course'

export default {
    name: 'coursedemand',

    data: function () {
        return {
            configs: {
                loading: false,
            },
            courseType4Demand: [],
            demand: {
                courseName: '',
                courseType: '',
                courseDescription: '',
                contactName: '',
                contactEmail: '',
                contactPhone: '',
            },
            demandRules: {
                courseType: [{ required: true, message: '請選擇建議開設的課程分類', trigger: 'change' }],
                courseName: [{ required: true, message: '請輸入建議開設的課程名稱', trigger: 'blur' }],
                courseDescription: [{ required: true, message: '請簡述建議開設的課程需求', trigger: 'blur' }],
                contactName: [{ required: true, message: '請輸入您的姓名', trigger: 'blur' }],
                contactEmail: [{ validator: checkEmail, trigger: 'blur' }],
                contactPhone: [{ validator: checkPhone, trigger: 'blur' }],
            },
            user: {
                isLogin: false,
                id: '',
                name: '',
                class: '',
                email: '',
            },
        }
    },

    created: function () {
        this.getCourseType4Demand()
    },

    mounted: function () {
        /* const vm = this
        const timer = window.setInterval(() => {
            vm.$store.dispatch('user/checkLogin').then(isLogin => {
                vm.user.isLogin = isLogin
            })
        }, 1000)
        // 组件銷毀前, 清除定時器
        vm.$once('hook:beforeDestroy', () => {
            window.clearInterval(timer)
        }) */
    },

    watch: {
        '$store.getters.isLogin': function (newVal, oldVal) {
            if (!XEUtils.isEqual(newVal, oldVal)) this.user.isLogin = newVal
        },
        '$store.getters.userInfo': function (newVal, oldVal) {
            const vm = this
            vm.user = newVal
            if (!XEUtils.isEqual(newVal, oldVal) && vm.user.isLogin) {
                vm.demand.contactName = vm.user.name
                vm.demand.contactEmail = vm.user.email
            } else if (!XEUtils.isEqual(newVal, oldVal) && !vm.user.isLogin) {
                vm.demand.contactName = ''
                vm.demand.contactEmail = ''
            }
        },
    },

    methods: {
        async getCourseType4Demand() {
            const vm = this
            await getCourseType4Demand().then(res => {
                vm.courseType4Demand = res.Items

                if (vm.demand.courseType === '' && vm.courseType4Demand.length > 0) {
                    vm.demand.courseType = vm.courseType4Demand[0].para_no
                }
            })
        },

        async submitCourseDemand() {
            const vm = this
            vm.configs.loading = true
            let params = {
                DemandCName: vm.demand.courseName,
                DemandCType: vm.demand.courseType,
                DemandCDescription: vm.demand.courseDescription,
                Name: vm.demand.contactName + (vm.user.isLogin || vm.user.id === '' ? '' : `（${vm.user.id}）`),
                Email: vm.demand.contactEmail,
                Phone: vm.demand.contactPhone,
            }
            await submitCourseDemand(params)
                .then(res => {
                    if (res.Code === 1) {
                        vm.$message({ type: 'success', message: res.Msg, dangerouslyUseHTMLString: true })
                    }
                })
                .then(() => {
                    vm.configs.loading = false
                    vm.$refs.form.resetFields()
                    vm.$refs.btnCancel.click()
                    if (vm.user.isLogin && vm.user.id !== '') {
                        vm.demand.contactName = vm.user.name
                        vm.demand.contactEmail = vm.user.email
                    }
                    vm.demand.courseType = vm.courseType4Demand[0].para_no
                })
        },

        submitDemand() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.submitCourseDemand()
                }
            })
        },
    },
}
</script>

<style scoped lang="scss">
:deep .el-form-item__label {
    text-align: center;
}
:deep .el-form-item__content {
    text-align: left;

    .text_sub {
        text-align: center;
    }

    .el-textarea textarea,
    .el-input input {
        color: #212529;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
    }

    .el-textarea textarea:focus,
    .el-input input:focus {
        background-color: #fff;
        border-color: #86b7fe;
        box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    }
}

.form-el-select {
    width: 130px;

    :deep .el-popper {
        border-radius: 10px;
    }

    :deep .el-scrollbar {
        text-align: left;
        border-color: #2d9698;

        li {
            // border-color: #2d9698;
            color: #2d9698;
            font-size: 1rem;
            border-radius: 10px;
        }
    }
}
:deep .el-select .el-input .el-input__inner {
    font-size: 1rem;
    color: #2d9698;
    border-color: #2d9698;
}
:deep .el-select .el-input.is-focus .el-input__inner {
    font-size: 1rem;
    color: #2d9698;
    border-color: #2d9698;
}
:deep .el-input.is-disabled .el-input__inner {
    border-color: #2d9698;
    background-color: #e9ecef;
}
.not-allowed:disabled {
    cursor: not-allowed;
    pointer-events: inherit;
    background-color: #4d4d4d !important;
}
</style>
